import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { EszkozService } from '../eszkoz.service';
import { UgyfelkorBeallitasComponent } from '../../components/ugyfelkor-beallitas/ugyfelkor-beallitas.component';

/**
 *  TÁRGYI ESZKÖZ – BEÁLLÍTÁSOK.
 *
 *  Intézményre: az ügyfélkör (kapcsolt: a Könyvelés ügyfelei / önálló: saját ügyfélkör). A kiválasztott
 *  cégre: az écs gyakorisága (havi / negyedéves feladás) és a kis értékű eszközök értékhatára. Kapcsolt
 *  cégnél a határ a Könyvelés kettős beállításaiból jön (ott módosítható); önálló cégnél itt adható meg
 *  (backend/kettos-eszkoz.js, eszkoz_beallitas).
 */
@Component({
  selector: 'app-eszkoz-beallitasok',
  standalone: true,
  imports: [CommonModule, FormsModule, UgyfelkorBeallitasComponent],
  templateUrl: './beallitasok.component.html',
})
export class EszkozBeallitasokComponent implements OnInit, OnDestroy {
  b: any = null;
  hatar: number | null = null;
  uzenet = '';
  hibaSz = '';
  fut = false;
  private sub?: Subscription;

  constructor(public eszkoz: EszkozService) {}
  get u() { return this.eszkoz.aktiv.ugyfelId; }

  async ngOnInit() { await this.eszkoz.init(); this.sub = this.eszkoz.aktiv$.subscribe(() => this.betolt()); }
  ngOnDestroy() { this.sub?.unsubscribe(); }

  async betolt() {
    this.b = null; this.uzenet = ''; this.hibaSz = '';
    if (!this.u) return;
    try { this.b = await this.eszkoz.getAbs(`/api/eszkoz/beallitas/${this.u}`); this.hatar = this.b.kis_erteku_hatar; }
    catch (e: any) { this.hibaSz = e?.error?.error || 'Nem sikerült betölteni a beállítást.'; }
  }
  async ment() {
    this.fut = true; this.uzenet = ''; this.hibaSz = '';
    try {
      await this.eszkoz.putAbs(`/api/eszkoz/beallitas/${this.u}`, { ecs_gyakorisag: this.b.ecs_gyakorisag, kis_erteku_hatar: this.b.onallo ? this.hatar : undefined });
      this.uzenet = 'Mentve.';
      await this.betolt(); this.uzenet = 'Mentve.';
    } catch (e: any) { this.hibaSz = e?.error?.error || 'Nem sikerült menteni.'; }
    this.fut = false;
  }
}
